import { render } from "./advice-item.vue?vue&type=template&id=34f4569b&scoped=true"
import script from "./advice-item.vue?vue&type=script&lang=js"
export * from "./advice-item.vue?vue&type=script&lang=js"

import "./advice-item.vue?vue&type=style&index=0&id=34f4569b&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f4569b"]])

export default __exports__